import * as React from "react";
import styled from "styled-components";
import { getLitbLangFn } from "utils/language/index";
import { config } from "config/config";

export const ErrorPageWrap = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 20px auto;
  padding: 91px 0 20px 0;
  width: 1190px;
  min-height: inherit;
  background: #fff;
  border-radius: 4px;

  img {
    width: 242px;
    height: 120px;
    display: block;
  }
  p {
    margin-top: 10px;
    max-width: 410px;
    text-align: center;
    font-size: 14px;
    font-family: Avenir-Roman, Avenir;
    font-weight: normal;
    color: #666666;
    line-height: 19px;
    font-weight: bold;
  }
  a {
    text-decoration: none;
    background: ${(props) => props?.theme?.primaryColor};
    min-width: 150px;
    height: 36px;
    display: block;
    margin: 10px auto;
    line-height: 36px;
    border-radius: 4px;
    text-align: center;
    color: #fff;
    font-weight: 500;
    padding: 0 12px;
    font-size: 14px;
  }
`;
export default function ErrorPage({ language = "en" }: { language: string }) {
  return (
    <ErrorPageWrap>
      <img src={config.pcErrorImg} alt="Page is blank" />
      <p>{getLitbLangFn("Page is blank", language)}</p>
      <a href="https://www.ouku.com/index.php?main_page=index">
        {getLitbLangFn("GoShopping", language)}
      </a>
    </ErrorPageWrap>
  );
}
